import { useCallback, useState } from "react";
import { MDBBtn } from "mdb-react-ui-kit";
import "./SectionListView.css";

import { doFetchJson } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { toast } from "Projects/CC_cubi_clan_project/GlobalComponents/ToastHost/ToastHost";
import { PopConfirm } from "Projects/CC_cubi_clan_project/GlobalComponents/PopConfirm/PopConfirm";
import SectionEditor from "Projects/EXHI_exhibiciones_project/Components/SectionEditor/SectionEditor";

function formatTime(seconds) {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

export default function SectionListView({ exhibicion, canManage, onRefresh, selectedId, onSelectSection }) {
  const [editSeccion, setEditSeccion]   = useState(null);
  const [showCreate,  setShowCreate]    = useState(false);
  const [dropTargetId, setDropTargetId] = useState(null);
  const [createZoneActive, setCreateZoneActive] = useState(false);

  const handleEditorClose = useCallback(() => {
    setEditSeccion(null);
    setShowCreate(false);
  }, []);

  const handleEditorSaved = useCallback(() => {
    setEditSeccion(null);
    setShowCreate(false);
    onRefresh && onRefresh();
  }, [onRefresh]);

  async function handleDelete(idSeccion) {
    console.log(`[EXHI:SectionList] handleDelete — idSeccion=${idSeccion}`);
    try {
      const res = await doFetchJson("EXHI", `secciones/${idSeccion}`, { method: "DELETE" });
      console.log("[EXHI:SectionList] handleDelete — respuesta:", res?.STATE, res?.MESSAGE);
      if (res?.STATE === "SUCCESS") {
        toast.show({ message: "Sección eliminada", type: "success" });
        onRefresh && onRefresh();
      } else {
        toast.show({ message: res?.MESSAGE || "Error al eliminar", type: "danger" });
      }
    } catch (err) {
      console.error("[EXHI:SectionList] handleDelete — ERROR:", err);
      toast.show({ message: "Error de conexión", type: "danger" });
    }
  }

  // ── Drop on section row ──────────────────────────────────────────────────────
  function handleRowDragOver(e, idSeccion) {
    if (!e.dataTransfer.types.includes("application/exhi-media")) return;
    e.preventDefault();
    e.dataTransfer.dropEffect = "copy";
    setDropTargetId(idSeccion);
  }

  function handleRowDragLeave() {
    setDropTargetId(null);
  }

  async function handleRowDrop(e, seccion) {
    e.preventDefault();
    setDropTargetId(null);
    const raw = e.dataTransfer.getData("application/exhi-media");
    if (!raw) return;
    let media;
    try { media = JSON.parse(raw); } catch (err) { console.error("[EXHI:SectionList] handleRowDrop — parse error:", err); return; }

    const isAudio = media.mediaType === "AUDIO";
    const endpoint = isAudio
      ? `secciones/${seccion.idSeccion}/medios/audio`
      : `secciones/${seccion.idSeccion}/medios/visual`;
    console.log(`[EXHI:SectionList] handleRowDrop — media sobre idSeccion=${seccion.idSeccion} "${seccion.titulo}" endpoint=${endpoint}`, media);
    try {
      const res = await doFetchJson("EXHI", endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ mfmUuid: media.uuid, mediaType: media.mediaType }).toString(),
      });
      console.log("[EXHI:SectionList] handleRowDrop — respuesta:", res?.STATE, res?.MESSAGE);
      if (res?.STATE === "SUCCESS") {
        toast.show({ message: `Medio añadido a "${seccion.titulo}"`, type: "success" });
        onRefresh && onRefresh();
      } else {
        toast.show({ message: res?.MESSAGE || "Error al añadir medio", type: "danger" });
      }
    } catch (err) {
      console.error("[EXHI:SectionList] handleRowDrop — ERROR:", err);
      toast.show({ message: "Error de conexión", type: "danger" });
    }
  }

  // ── Drop zone CREATE (at the bottom) ────────────────────────────────────────
  function handleCreateZoneDragOver(e) {
    if (!e.dataTransfer.types.includes("application/exhi-media")) return;
    e.preventDefault();
    e.dataTransfer.dropEffect = "copy";
    setCreateZoneActive(true);
  }

  function handleCreateZoneDragLeave() {
    setCreateZoneActive(false);
  }

  async function handleCreateZoneDrop(e) {
    e.preventDefault();
    setCreateZoneActive(false);
    const raw = e.dataTransfer.getData("application/exhi-media");
    if (!raw) return;
    let media;
    try { media = JSON.parse(raw); } catch (err) { console.error("[EXHI:SectionList] handleCreateZoneDrop — parse error:", err); return; }

    const duracion = media.duracion ? Math.ceil(media.duracion) : 60;
    const tiempoInicio = secciones.length > 0
      ? Math.max(...secciones.map((s) => s.tiempoInicio + s.duracion))
      : 0;
    console.log(`[EXHI:SectionList] handleCreateZoneDrop — crear sección tiempoInicio=${tiempoInicio} duracion=${duracion}`, media);

    try {
      const res = await doFetchJson("EXHI", `exhibiciones/${exhibicion.idExhibicion}/secciones`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          titulo: media.titulo || "Nueva sección",
          tiempoInicio: String(tiempoInicio),
          duracion: String(duracion),
        }).toString(),
      });
      console.log("[EXHI:SectionList] handleCreateZoneDrop — respuesta crear:", res?.STATE, res?.MESSAGE, "id:", res?.DATA?.idSeccion);
      if (res?.STATE !== "SUCCESS") {
        toast.show({ message: res?.MESSAGE || "Error al crear sección", type: "danger" });
        return;
      }
      const newId = res.DATA.idSeccion;
      const isAudio = media.mediaType === "AUDIO";
      const endpt = isAudio ? `secciones/${newId}/medios/audio` : `secciones/${newId}/medios/visual`;
      console.log(`[EXHI:SectionList] handleCreateZoneDrop — añadiendo medio al idSeccion=${newId} endpoint=${endpt}`);
      const resM = await doFetchJson("EXHI", endpt, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ mfmUuid: media.uuid, mediaType: media.mediaType }).toString(),
      });
      console.log("[EXHI:SectionList] handleCreateZoneDrop — respuesta medio:", resM?.STATE, resM?.MESSAGE);
      toast.show({ message: `Sección "${media.titulo || "Nueva sección"}" creada`, type: "success" });
      onRefresh && onRefresh();
    } catch (err) {
      console.error("[EXHI:SectionList] handleCreateZoneDrop — ERROR:", err);
      toast.show({ message: "Error de conexión", type: "danger" });
    }
  }

  const secciones = exhibicion?.secciones || [];

  return (
    <div>
      <div className="exhi-section-list">
        {secciones.length === 0 && (
          <div className="exhi-empty text-muted text-center py-4">No hay secciones aún.</div>
        )}
        {secciones.map((s) => (
          <div
            key={s.idSeccion}
            className={[
              "exhi-section-item",
              selectedId === s.idSeccion  ? "exhi-section-item--selected"   : "",
              dropTargetId === s.idSeccion ? "exhi-section-item--drop-target" : "",
            ].filter(Boolean).join(" ")}
            onClick={() => onSelectSection && onSelectSection(s)}
            onDragOver={(e) => handleRowDragOver(e, s.idSeccion)}
            onDragLeave={handleRowDragLeave}
            onDrop={(e) => handleRowDrop(e, s)}
            style={{ cursor: "pointer" }}
          >
            <div className="exhi-section-time">
              {formatTime(s.tiempoInicio)} – {formatTime(s.tiempoFin)}
              <br />
              <span className="text-muted">({s.duracion}s)</span>
            </div>
            <div className="exhi-section-body">
              <div className="exhi-section-title">{s.titulo}</div>
              {s.descripcion && <div className="exhi-section-desc">{s.descripcion}</div>}
              <div className="exhi-section-medios">
                {s.medioVisual && s.medioVisual.thumbUrl && (
                  <img src={s.medioVisual.thumbUrl} alt="visual" className="exhi-section-medio-thumb" />
                )}
                {s.medioVisual && !s.medioVisual.thumbUrl && (
                  <span className="exhi-section-medio-audio">🖼 Visual</span>
                )}
                {(s.mediosAudio || []).map((a, i) => (
                  <span key={i} className="exhi-section-medio-audio">🎵 {a.tituloMfm || `Audio ${i + 1}`}</span>
                ))}
              </div>
            </div>
            {canManage && (
              <div className="exhi-section-actions" onClick={(e) => e.stopPropagation()}>
                <MDBBtn size="sm" color="link" onClick={() => setEditSeccion(s)}>
                  Editar
                </MDBBtn>
                <PopConfirm
                  message="¿Eliminar esta sección?"
                  onConfirm={() => handleDelete(s.idSeccion)}
                >
                  <MDBBtn size="sm" color="danger" outline>
                    Eliminar
                  </MDBBtn>
                </PopConfirm>
              </div>
            )}
          </div>
        ))}
      </div>

      {canManage && (
        <div
          className={`exhi-section-create-zone${createZoneActive ? " active" : ""}`}
          onDragOver={handleCreateZoneDragOver}
          onDragLeave={handleCreateZoneDragLeave}
          onDrop={handleCreateZoneDrop}
          onClick={() => setShowCreate(true)}
        >
          <span className="exhi-section-create-zone-icon">＋</span>
          <span className="exhi-section-create-zone-label">
            {createZoneActive ? "Suelta para crear sección" : "Nueva sección"}
          </span>
        </div>
      )}

      {canManage && (
        <div className="exhi-add-section-row">
          <MDBBtn size="sm" color="secondary" onClick={() => setShowCreate(true)}>
            + Añadir sección
          </MDBBtn>
        </div>
      )}

      {(editSeccion || showCreate) && (
        <SectionEditor
          show={!!(editSeccion || showCreate)}
          setShow={handleEditorClose}
          idExhibicion={exhibicion.idExhibicion}
          seccion={editSeccion}
          onSaved={handleEditorSaved}
        />
      )}
    </div>
  );
}
